<p-sidebar [(visible)]="showExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="changedVisibleExportSidebar(false)"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div class="flex flex-column mt-2">
        <label class="export-data-label mb-2">File Type</label>
        <p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select" optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
    </div>
    <div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
        <button class="btn-darkblue" pButton label="Download" (click)="exportQuests()"></button>
    </div>
</p-sidebar>

<p-sidebar [(visible)]="showFinishRaffleSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="closeRaffleSidebar()"
           [style]="{width:'675px'}">
    <ng-template pTemplate="header">Finish Raffle</ng-template>

    <p-scrollPanel >
        <ng-container *ngFor="let winner of winners; let i = index;">
            <div class="mt-3 winner">Winner {{i+1}}</div>

            <div class="mt-3 ml-1 mr-1 flex">
                <div class="" style="width: 287px;">
                    <label class="finish-raffle-label mb-2">Name</label>
                    <input [disabled]="formDisabled" [ngClass]="{'input-disabled': formDisabled}" id="name{{i+1}}" (focusout)="validateField('nameErr'+(i+1), 'name'+(i+1))" class="name{{i+1}} input-winner mt-2" [(ngModel)]="winner.Name" placeholder="Enter Name" />
                    <div class="err mt-1 nameErr{{i+1}}" id="nameErr{{i+1}}">This field is required</div>
                </div>
                <div class="ml-auto">
                    <label class="finish-raffle-label mb-2">Ticket Number</label>
                    <input [disabled]="formDisabled" [ngClass]="{'input-disabled': formDisabled}" id="ticket{{i+1}}" (focusout)="validateTicketNumber('ticketErr'+(i+1), 'ticket'+(i+1), winner.TicketNumber)" class="ticket{{i+1}} input-winner mt-2" [(ngModel)]="winner.TicketNumber" placeholder="Enter Number" />
                    <div class="err mt-1 ticketErr{{i+1}}" id="ticketErr{{i+1}}"></div>
                </div>
            </div>

            <div class="mt-3 ml-1 mr-1">
                <label class="finish-raffle-label mb-2">Prize</label>
                <input [disabled]="formDisabled" [ngClass]="{'input-disabled': formDisabled}" id="prize{{i+1}}" (focusout)="validateField('prizeErr'+(i+1), 'prize'+(i+1))" class="input-winner mt-2" [(ngModel)]="winner.Prize" placeholder="Enter Prize" />
                <div class="err mt-1" id="prizeErr{{i+1}}">This field is required</div>
            </div>
        </ng-container>


        <div *ngIf="((timeSlice === TimeSliceEnum.EarlyBird && winners.length < 15) ||
                    (timeSlice === TimeSliceEnum.HolidayRush && winners.length < 5) ||
                    (timeSlice === TimeSliceEnum.YearEndCraze && winners.length < 2) ||
                    (timeSlice === TimeSliceEnum.GrandPrize && winners.length < 1)) && !formDisabled" style="width: 145px; cursor: pointer;" class="mt-3" (click)="addWinner()">
            <img class="btn-icon" style="margin-left: 20px" src="Content/xpress-app/images/plus-in-circle.svg" alt='' height="14" width="14">
            <div class="btn-winner"><div class="ml-3" style="padding-top: 9px;">Add winner</div></div>
        </div>
    </p-scrollPanel>

    <ng-template pTemplate="footer">
        <div class="mb-5 flex justify-content-end">
            <div *ngIf="formDisabled" class="btn-darkblue" (click)="closeRaffleSidebar()">Close</div>
            <div *ngIf="!formDisabled" class="btn-close" (click)="closeRaffleSidebar()">Close</div>
            <div *ngIf="!formDisabled" class="btn-darkblue ml-3" (click)="finishRaffle()">Finish</div>
        </div>
    </ng-template>
</p-sidebar>

<p-dialog
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [resizable]="false"
        [(visible)]="exportLoading"
        [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <span class="dialog-header">Downloading data</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data</div>
        <div class="mt-4 spinner"></div>
    </ng-template>
</p-dialog>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-toast position="top-right"></p-toast>

    <div class="mt-2 mb-4 report-title">Customer Quest</div>

    <p-tabMenu class="mb-5" [model]="menuTabItems" [activeItem]="activeTabItem"></p-tabMenu>
    <div class="mb-3"></div>
    <div class="flex-row mb-3">
        <input pInputText class="quests-search-input" [(ngModel)]="searchName" (ngModelChange)="onChangeFilter()" placeholder="Select Name or Ticket Number" />

        <div style="display: flex; margin-left: auto">
            <div style="width: 136px; cursor: pointer;" class="mr-3" (click)="showRaffleSidebar()">
                <img *ngIf="!formDisabled" class="btn-icon" [ngClass]="{'btn-disabled': !this.selectedDate || (timeSlice === TimeSliceEnum.GrandPrize && !isQuestsEnded())}" src="Content/xpress-app/images/finish-raffle.svg" alt='' height="14" width="14">
                <div pRipple [ngClass]="{'btn-disabled': !this.selectedDate || (timeSlice === TimeSliceEnum.GrandPrize && !isQuestsEnded())}" class="{{formDisabled ? 'btn-view ': 'btn'}} btn-finish-raffle">{{formDisabled ? 'View Winners': 'Finish Raffle'}}</div>
            </div>

            <div style="cursor: pointer;">
                <img class="btn-icon" src="Content/xpress-app/images/export-dark.svg" alt='' height="14" width="14">
                <div pRipple [ngClass]="{'btn-disabled': !this.selectedDate}" class="btn btn-export" (click)="showSidebar()">Export</div>
            </div>

            <div class="ml-3 mt-1 mr-2">
                <column-selector #columnSelector
                     [defaultColumns]="defaultCols"
                     (selectedColumnsChange)="onSelectedColumnsChange($event)"
                     [tableName]="tableName"
                     [(selectedColumns)]="cols">
                </column-selector>
            </div>
        </div>
    </div>

    <div class="card">
        <p-table [columns]="cols"
                 [value]="quests"
                 [lazy]="true"
                 responsiveLayout="auto"
                 selectionMode="single"
                 dataKey="XpressUserId"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [selection]="selectedQuest"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [autoLayout]="true"
                 [loading]="loading"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-quest let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" [pSelectableRow]="quest">
                        {{ quest[col.field] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="quests && quests.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + quests.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>

        <img *ngIf="!quests || quests.length === 0" class="no-entries" src="Content/xpress-app/images/no-entries.jpg" alt=''>
    </div>
</div>

<!--<quest-details *ngIf="showDetailTransactionSidebar" TODO -->
<!--                          [showTransactionsSidebar]="showDetailTransactionSidebar"-->
<!--                          (updateTransactionsEmit)="updateEventEmit($event)"-->
<!--                          [transaction]="selectedQuest">-->
<!--</quest-details>-->
